import { connect } from 'react-redux';
import EnrollAuthor from './EnrollAuthor';
import { addAuthor, removeAuthor, getAuthors } from '../../actions/bootcampActions';

export default connect(null, {
  addAuthor,
  removeAuthor,
  getAuthors,
})(EnrollAuthor);
